module.exports = __webpack_public_path__ + "img/2.c4d1822f.png";